import React, { Component } from "react";
import { PropTypes } from "prop-types";
import cx from "classnames";
import { Amenities, RawHTML } from "../common";
import PriceDisplay from "../../containers/PriceDisplay";
import styles from "./styles.less";
import { Gallery } from "../";

class RoomData extends Component {
  state = {
    showReadMore: false,
    galleryWidthExpanded: null,
    galleryWidthCollapsed: null,
    roomDetailsWidthExpanded: null,
    roomDetailsWidthCollapsed: null,
    initialLoading: true,
    resizeOccured: false,
    roomView: false
  };

  componentDidMount() {
    this.isReadMoreOverlapping(); // after first mount ( refs already got attached ) , update showReadMore flag.
    window.addEventListener("resize", this.isReadMoreOverlapping); // add showReadMore flag updating callback to window resize event.
    this.resizeImageAndRoomDetails();
  }

  componentDidUpdate() {
    // if we got from thumbnail view (didnt need read more btn) to room view, check again this function
    if (!this.state.roomView) {
      if (
        this.props.routing &&
        this.props.routing.location.pathname.indexOf("/room") > 0
      ) {
        this.setState({
          roomView: true
        });
        this.isReadMoreOverlapping();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.isReadMoreOverlapping);
  }

  innerRoomDescriptionRef = null;
  outerRoomDescriptionRef = null;

  /** check if the wrapper element of the room description TEXT is higher
   * than the wrapper element of the room description area ( inc read more text and fader ).
   * if so, the fader (inc read more text) should be applied on the dom and be visible to the user.
   */
  isReadMoreOverlapping = () => {
    let newState = {
      showReadMore: false
    };

    if (
      //this.state.roomDetailsWidthCollapsed &&
      this.innerRoomDescriptionRef &&
      this.outerRoomDescriptionRef &&
      this.innerRoomDescriptionRef.offsetHeight > 100 &&
      this.innerRoomDescriptionRef.offsetHeight >=
        this.outerRoomDescriptionRef.offsetHeight
    ) {
      newState.showReadMore = true;
    }

    this.setState(newState);
  };

  setOuterRoomDescriptionRef = ref => (this.outerRoomDescriptionRef = ref);

  setInnerRoomDescriptionRef = ref => (this.innerRoomDescriptionRef = ref);

  setGalleryRoomRef = ref => (this.galleryRoomRef = ref);

  setRoomDetailsRef = ref => (this.roomDetailsRef = ref);

  setRoomHeaderRef = ref => (this.roomHeaderRef = ref);

  resizeImageAndRoomDetails = () => {
    const isInitial = this.state.initialLoading;
    //const { expandbleState } = this.props;
    if (isInitial && this.roomHeaderRef) {
      this.setState({
        galleryWidthExpanded: this.roomHeaderRef.offsetWidth / 2,
        galleryWidthCollapsed: this.roomHeaderRef.offsetWidth / 4,
        roomDetailsWidthExpanded: this.roomHeaderRef.offsetWidth / 2,
        roomDetailsWidthCollapsed: (this.roomHeaderRef.offsetWidth * 3) / 4,
        initialLoading: false
      });
    }
  };

  renderGallery = () => {
    const { images, isRtl, room } = this.props;
    return (
      <div
        className={styles.rateImageWrapper}
        onClick={this.onShowRoomGalleryPopUp}
        onKeyDown={this.onShowRoomGalleryPopUp}
        key={room && room.id + "images"}
        role="button"
        tabIndex="0"
        ref={this.setGalleryRoomRef}
      >
        <Gallery
          images={images}
          isRtl={isRtl}
          showNav={false}
          autoPlay={true}
          //switchImagesAutomatically != null ? true : switchImagesAutomatically (taken from props)
          //}
          showIndex={false}
          showMagnify={true}
        />
      </div>
    );
  };

  onShowRoomGalleryPopUp = () => {
    const { onShowRoomGalleryPopUp, room } = this.props;
    onShowRoomGalleryPopUp(room);
  };

  onShowMoreAmenities = () => {
    const { onShowMoreAmenities, room } = this.props;
    onShowMoreAmenities(room.id);
  };

  onRoomDetailsClick = () => {
    const { room, onRoomDetailsClick } = this.props;
    onRoomDetailsClick(room.id);
  };

  toggleExpandbleResults = () => {
    this.setState({ resizeOccured: true });
    const { toggleExpandbleResultsView, room, selectedPaxId } = this.props;
    toggleExpandbleResultsView({
      id: room.id,
      name: room.name,
      requestDescriptor: selectedPaxId
    });
  };

  startFromPrice = price => {
    const { titles } = this.props;
    const startFromPrice = price && `${titles.StartingFrom} ${price}`;
    return startFromPrice;
  };

  findLowestPrice = () => {
    const { room } = this.props;
    const isData = room && room.rates;
    let lowestPrice = isData && room.rates && room.rates[0].totalPrice;
    room.rates &&
      room.rates.forEach(rate => {
        if (rate.totalPrice < lowestPrice) {
          lowestPrice = rate.totalPrice;
        }
      });
    return lowestPrice;
  };

  renderRoomDetails = () => {
    const { room, isRtl, titles, expandbleState } = this.props;
    const { showReadMore } = this.state;
    const numberOfAmenitiesToShow = 5;
    const amenitiesPreviewLimit =
      room.amenities && room.amenities.length < numberOfAmenitiesToShow
        ? room.amenities.length
        : numberOfAmenitiesToShow;
    const displayShowMoreAmeneties =
      room.amenities && room.amenities.length > numberOfAmenitiesToShow;
    const amenitiesToPreview =
      room.amenities && room.amenities.slice(0, amenitiesPreviewLimit);
    const hasAmeneties =
      amenitiesToPreview != null && amenitiesToPreview.length > 0;
    const shouldSpaceBetweenAmeneties =
      amenitiesToPreview && amenitiesToPreview.length > 3;
    const lowestPrice = this.findLowestPrice();

    return (
      <div
        className={styles.roomDetailsWrapper}
        key={room && room.id}
        ref={this.setRoomDetailsRef}
      >
        <div className={styles.roomDetailsUpperWrapper}>
          <div className={styles.roomName}>{room.name}</div>
          <div
            className={cx(styles.roomDescriptionWrapper, {
              [styles.roomDescriptionWrapperBorder]: hasAmeneties
            })}
          >
            <div
              className={styles.roomDescriptionFade}
              ref={this.setOuterRoomDescriptionRef}
            >
              <div
                className={cx(styles.roomDescriptionReadMore, {
                  [styles.show]: showReadMore
                })}
                onClick={this.onRoomDetailsClick}
                onKeyDown={this.onRoomDetailsClick}
                role="button"
                tabIndex="0"
              >
                <div className={styles.roomDescriptionReadMoreText}>
                  {titles.ReadMore}
                </div>
              </div>
              {room.description && (
                <RawHTML
                  html={room.description}
                  className={styles.roomDescription}
                  callbackRef={this.setInnerRoomDescriptionRef}
                />
              )}
            </div>
          </div>
          {hasAmeneties && (
            <div className={styles.roomAmeneties}>
              <Amenities
                amenities={amenitiesToPreview}
                isRtl={isRtl}
                spaced={shouldSpaceBetweenAmeneties}
                includeName={true}
              />
              <div className={styles.showMoreAmenities}>
                {displayShowMoreAmeneties && (
                  <button
                    onClick={this.onShowMoreAmenities}
                    className={styles.showMoreAmenitiesBtn}
                  >
                    {titles.ShowMoreAmenities}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
        {lowestPrice && (
          <div className={styles.roomDataFooter}>
            {/* <div className={styles.roomAvailability}>
              <div className={styles.availabilityCircle}>
                {room.availability}
              </div>
              <div className={styles.availabilityText}>{titles.RoomsLeft}</div>
            </div> */}
            <div
              className={cx(styles.startFromPrice, {
                [styles.startFromPriceVisible]: !expandbleState
              })}
            >
              <PriceDisplay
                price={lowestPrice}
                currentCurrencyCode={room.currencyCode}
                fallBackCurrencySymbol={room.currency}
              >
                {calcPrice => this.startFromPrice(calcPrice)}
              </PriceDisplay>
            </div>
            {/* <div
              className={styles.showRatesButton}
              onClick={this.toggleExpandbleResults}
              onKeyDown={this.toggleExpandbleResults}
              role="button"
              tabIndex="0"
            >
              {expandbleState ? titles.HideRates : titles.ShowRates}
            </div> */}
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      galleryWidthExpanded,
      galleryWidthCollapsed,
      roomDetailsWidthExpanded,
      roomDetailsWidthCollapsed
    } = this.state;
    const { expandbleState } = this.props;
    const galleryWidth = expandbleState
      ? `${galleryWidthExpanded}px`
      : `${galleryWidthCollapsed}px`;
    const roomDetailsWidth = expandbleState
      ? `${roomDetailsWidthExpanded}px`
      : `${roomDetailsWidthCollapsed}px`;
    return (
      <div className={styles.roomHeader} ref={this.setRoomHeaderRef}>
        <div
          className={styles.roomGallerySection}
          style={{ width: galleryWidth || "100%" }}
        >
          {" "}
          {this.renderGallery()}
        </div>
        <div
          className={styles.roomDataSection}
          style={{ width: roomDetailsWidth || "100%" }}
        >
          {this.renderRoomDetails()}
        </div>
      </div>
    );
  }
}

RoomData.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  room: PropTypes.object,
  images: PropTypes.array,
  onShowMoreAmenities: PropTypes.func,
  onShowRoomGalleryPopUp: PropTypes.func,
  onRoomDetailsClick: PropTypes.func,
  //switchImagesAutomatically: PropTypes.bool,
  toggleExpandbleResultsView: PropTypes.func,
  selectedPaxId: PropTypes.number,
  expandbleState: PropTypes.bool,
  routing: PropTypes.object
};

export default RoomData;



// WEBPACK FOOTER //
// ./src/components/RoomData/RoomData.js